import React from 'react';
import { fontSans, pageGutter, warmHeaderBg } from './requestChangesStyles';

function ActionName({ children }) {
  return (
    <span className="request-changes-guidance-action">
      {children}
    </span>
  );
}

export default function RequestChangesGuidancePanel({ onDismiss }) {
  return (
    <div
      className="no-print request-changes-guidance-panel"
      role="region"
      aria-label="Request changes guidance"
      style={{
        width: '100%',
        boxSizing: 'border-box',
        backgroundColor: warmHeaderBg,
        position: 'relative'
      }}
    >
      <style>{`
        .request-changes-guidance-inner {
          width: 100%;
          box-sizing: border-box;
          margin: 0;
          padding: 20px ${pageGutter}px 22px;
          text-align: left;
        }
        .request-changes-guidance-copy {
          max-width: 640px;
        }
        .request-changes-guidance-action {
          font-weight: 600;
          color: #2C2C2C;
        }
        .request-changes-guidance-dismiss {
          position: absolute;
          top: 12px;
          right: ${pageGutter}px;
        }
        .request-changes-guidance-dismiss:focus-visible {
          outline: 2px solid #2C2C2C;
          outline-offset: 3px;
        }
        @media screen and (min-width: 769px) and (max-width: 1024px) {
          .request-changes-guidance-inner,
          [data-client-shareable-link="true"] .request-changes-guidance-inner {
            padding-left: 24px !important;
            padding-right: 24px !important;
          }
          .request-changes-guidance-dismiss,
          [data-client-shareable-link="true"] .request-changes-guidance-dismiss {
            right: 24px !important;
          }
        }
        @media screen and (max-width: 768px) {
          .request-changes-guidance-inner {
            padding: 14px 20px 16px !important;
          }
          .request-changes-guidance-copy {
            max-width: 100% !important;
            padding-right: 40px;
          }
          .request-changes-guidance-dismiss {
            top: 8px !important;
            right: 12px !important;
          }
        }
      `}</style>
      <button
        type="button"
        className="request-changes-guidance-dismiss"
        onClick={onDismiss}
        aria-label="Dismiss request changes guidance"
        style={{
          width: 28,
          height: 28,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'none',
          border: 'none',
          padding: 0,
          color: '#8a8378',
          fontSize: 20,
          lineHeight: 1,
          cursor: 'pointer',
          fontFamily: fontSans
        }}
      >
        ×
      </button>
      <div className="request-changes-guidance-inner">
        <p
          className="request-changes-guidance-copy"
          style={{
            margin: 0,
            fontFamily: fontSans,
            fontSize: 13,
            lineHeight: 1.55,
            color: '#6b645c'
          }}
        >
          Adjust quantities using the − / + controls, or remove products you no longer need. To add something new, choose <ActionName>Add New Product</ActionName> at the bottom of the page. When you're finished, choose <ActionName>Continue</ActionName> to review your changes and update project dates, times, or other details.
        </p>
      </div>
    </div>
  );
}
